import ServicePageTemplate from "@/pages/services/components/ServicePageTemplate";
import { getServiceDetail } from "@/mocks/services";

export default function OfficeShiftingPage() {
  const detail = getServiceDetail("office-shifting");
  if (!detail) return null;
  return <ServicePageTemplate detail={detail} />;
}